<template>
  <Layout title="Buchen" h1="Buchen" :banner="$page.props.banner">
    <booking @on-next="onSubmit">
      <div class="row">
        <div class="col-md-6 mt-4 mt-md-0">
          <!-- List participants -->
          <template v-if="participants">
            <table class="table table-borderless">
              <thead>
                <tr
                  class="text-primary border-bottom border-dark headings-font-family"
                >
                  <td>Teilnehmer</td>
                  <td class="text-end">Preis</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(participant, index) in participants"
                  :key="'booking-participant-show-' + index"
                >
                  <td>
                    {{ participant.firstname }} {{ participant.lastname }}
                  </td>
                  <td class="text-end">
                    <strong>
                      <price :given="participant.price" :digits="2" />
                    </strong>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td class="text-primary headings-font-family">Gesamtpreis</td>
                  <td class="text-end">
                    <strong>
                      <price :given="bookingForm.price" :digits="2" />
                    </strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </template>
        </div>
        <div class="col-md-6 mt-4 mt-md-0">
          <h3 class="text-primary">Zahlungsmethode</h3>
          <div class="form-check mt-2">
            <input
              class="form-check-input"
              type="checkbox"
              :class="{ 'is-invalid': errors.payment_method }"
              v-model="form.payment_method"
              true-value="invoice"
              false-value="null"
              value="invoice"
              id="payment-method"
              checked
              disabled
            />
            <label class="form-check-label" for="payment-method">
              auf Rechnung
            </label>
            <div class="invalid-feedback" v-if="errors.payment_method">
              {{ errors.payment_method }}
            </div>
          </div>
          <div class="form-text">
            Derzeit ist eine Zahlung nur auf Rechnung möglich.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 mt-4 mt-md-0">
          <h3 class="text-primary">Notizen</h3>
          <textarea
            v-model="form.note"
            class="form-control rounded-0 border-0"
            rows="5"
            placeholder="Schreibe etwas..."
            @blur="syncModel()"
          ></textarea>
        </div>
        <div class="col-md-6 mt-4 mt-md-0">
          <h3 class="text-primary">Buchungsbedingungen</h3>

          <!-- AGB -->
          <div class="form-check mt-2">
            <input
              class="form-check-input"
              type="checkbox"
              :class="{ 'is-invalid': errors.terms }"
              v-model="form.terms"
              value="1"
              id="booking-terms"
            />
            <label class="form-check-label" for="booking-terms">
              Ich bestätige die <a target="_blank" :href="$route('conditions')">Reisebedingungen</a>.
            </label>
            <div class="invalid-feedback" v-if="errors.terms">
              {{ errors.terms }}
            </div>
          </div>

          <!-- Datenschutz -->
          <div class="form-check mt-2">
            <input
              class="form-check-input"
              type="checkbox"
              :class="{ 'is-invalid': errors.privacy }"
              v-model="form.privacy"
              value="1"
              id="booking-privacy"
            />
            <label class="form-check-label" for="booking-privacy">
              Ich akzeptiere den <a target="_blank" :href="$route('data-protection')">Datenschutz</a>.
            </label>
            <div class="invalid-feedback" v-if="errors.privacy">
              {{ errors.privacy }}
            </div>
          </div>

          <!-- Reiseversicherung -->
          <div class="form-check mt-2">
            <input
              class="form-check-input"
              type="checkbox"
              :class="{ 'is-invalid': errors.travel_insurance }"
              v-model="form.travel_insurance"
              value="1"
              id="booking-travel_insurance"
            />
            <label class="form-check-label" for="booking-travel_insurance">
              Reiseversicherung gewünscht
            </label>
            <div class="form-text">
                Im nächsten Schritt befinden sich weitere Infos zur Reiseversicherung.
          </div>
            <div class="invalid-feedback" v-if="errors.travel_insurance">
              {{ errors.travel_insurance }}
            </div>
          </div>

          <div id="booking-errors" class="mt-3" v-if="hasBookingErrors">
            <p class="text-danger mb-1">
              Die Buchung konnte <strong>nicht abgeschlossen</strong> werden.
            </p>
            <ul class="mb-0">
              <li
                v-for="(error, code) in errors"
                :key="'error-' + code"
                class="lh-1 mb-1"
              >
                {{ error }}<br />
                <span class="text-muted"
                  ><small>{{ code }}</small></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        class="position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-75 d-flex justify-content-center align-items-center"
        v-if="store.loading"
      >
        <div class="text-center">
          <span class="text-primary headings-font-family fs-3"
            >Wir bereiten deine Reise vor...</span
          ><br />
          <spinner />
        </div>
      </div>
    </booking>
  </Layout>
</template>
<script>
import { Link, useForm } from "@inertiajs/inertia-vue3";
import Layout from "../Layouts/Booking";
import Booking from "./Booking";
import Login from "./Login";
import BookingFormModel from "../../Models/BookingFormModel";
import Travel from "../../Models/Travel";
import TravelDate from "../../Models/TravelDate";
import Price from "../../Components/Scol/Price";
import ArrivalIcon from "../../Components/Scol/ArrivalIcon";
import ConfirmDelete from "../../Components/Scol/ConfirmDelete";
import FormsInfo from "../../Components/Forms/Info";
import { store } from "../../store";
import Spinner from "../../Components/Scol/Spinner";

export default {
  components: {
    Layout,
    Link,
    Booking,
    Price,
    ArrivalIcon,
    ConfirmDelete,
    FormsInfo,
    Login,
    Spinner,
  },
  props: {
    errors: Object,
    bookingForm: Object,
  },
  data: () => ({
    store,
    watchers_enabled: false,
    form: useForm({
      show: true,
      payment_method: "invoice",
      note: null,
      terms: null,
      privacy: null,
      travel_insurance: null,
    }),
  }),
  methods: {
    syncModel(reload = false, callback) {
      // console.log(newParticipant);
      return this.model
        .set("note", this.form.note)
        .toStorage()
        .syncToServer()
        .then(() => {
          if (reload) {
            // console.log("RELOAD");
            this.reloadOnly(callback);
          }
        });
    },
    onSubmit() {
      store.loading = true;
      this.form
        .transform((data) => ({
          ...this.bookingForm.data,
          ...data,
          travel_insurance: !!data.travel_insurance,
        }))
        .post(this.$route("booking.send", { t: this.$session.tab_id }), {
          preserveScroll: true,
          onFinish: () => (store.loading = false),
        });
    },
    reloadOnly(only) {
      let data = { t: this.$session.tab_id };
      this.$inertia.reload({
        data: data,
        // only: only,
      });
    },
    enableWatchers() {
      this.watchers_enabled = true;
    },
    disableWatchers() {
      this.watchers_enabled = false;
    },
    watchersEnabled() {
      return this.watchers_enabled == true;
    },
  },
  mounted() {
    this.form.note = this.model.get("note");
    this.enableWatchers();
  },
  computed: {
    model() {
      return BookingFormModel.make(this.bookingForm).setSession(this.$session);
    },
    travelDate() {
      if (!_.get(this.bookingForm, "travel_date")) {
        return null;
      }
      return new TravelDate(this.bookingForm.travel_date);
    },
    travel() {
      if (!_.get(this.bookingForm, "travel")) {
        return null;
      }
      return new Travel(this.bookingForm.travel);
    },
    participants() {
      if (!this.bookingForm) {
        return [];
      }
      return this.bookingForm.participants;
    },
    participants_count() {
      if (!this.participants) {
        return 0;
      }
      return this.participants.length;
    },
    hasBookingErrors() {
      return !_.isEmpty(this.bookingErrors);
    },
    bookingErrors() {
      const ignore = ["terms", "privacy"];
      return _.filter(this.errors, (error, key) => !ignore.includes(key));
    }
  },
};
</script>
